import React, {useEffect} from 'react';
import {useFormik} from "formik";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from "@material-ui/core";

const EditNormativeChapterDialog = (props) => {
    const {open, onClose, submitCallback, initialValues} = props

    const onSubmit = async (values) => {
        await submitCallback(values)
    }

    const {getFieldProps, resetForm, submitForm, setValues} = useFormik({
        initialValues: {
            id: undefined,
            name: '',
            number: undefined
        },
        onSubmit: onSubmit
    })

    const handleCloseDialog = () => {
        onClose()
        resetForm()
    }

    const handleSubmitButtonClick = async () => {
        await submitForm()
        handleCloseDialog()
    }

    useEffect(() => {
        if (open && initialValues) {
            setValues(initialValues)
        }
    }, [open, initialValues])

    return (
        <Dialog open={open} onClose={handleCloseDialog} maxWidth={"sm"} fullWidth>
            <DialogTitle>Редактирование главы</DialogTitle>
            <DialogContent>
                <TextField label={'Номер главы'} fullWidth name={'number'} {...getFieldProps('number')}/>
                <TextField label={'Название главы'} fullWidth multiline name={'name'} {...getFieldProps('name')}/>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog}>
                    Отмена
                </Button>
                <Button onClick={handleSubmitButtonClick}>
                    Сохранить
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditNormativeChapterDialog;